import { useSignupState } from './useSignupState'

export const useSignupSession = () => useSignupState().signupSession
